exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".otp-verify {\r\n    background: #fff !important;\r\n    height: 100%;\r\n}\r\n.otp_btn{\r\n    width: 30%;\r\n    background: #015b99;\r\n    color: #fff;\r\n    border-radius: 30px;\r\n    /* text-align: center; */\r\n    padding: 12px 0;\r\n    border: 0;\r\n}\r\n.back-login{\r\n    font-size  : 12px;\r\n    margin-top : 5px;\r\n}", ""]);

